
import copy from 'copy-text-to-clipboard';
import {
  defineComponent, onBeforeUnmount, PropType, ref
} from 'vue';
import BCXPanel from '@/components/molecules/BCXPanel.vue';
import useResponsiveness from '@/mixins/useResponsiveness';
import BCXPanelFullscreenMobile from '@/components/molecules/BCXPanelFullscreenMobile.vue';
import LRPopupMobileHeader from '@/components/login-register/LRPopupMobileHeader.vue';

export default defineComponent({
  name: 'LRPopup',
  components: { LRPopupMobileHeader, BCXPanel, BCXPanelFullscreenMobile },
  props: {
    title: {
      type: String,
      default: ''
    },
    type: {
      type: String as PropType<'confirm' | 'content'>,
      default: 'confirm'
    },
    value: {
      type: [Boolean, String],
      default: false
    },
    showCopyIcon: Boolean,
    copyText: {
      type: String,
      default: ''
    },
    copyFeedbackText: {
      type: String,
      default: 'Kopiert'
    }
  },
  setup(props, { emit }) {
    const { isMobileWidth } = useResponsiveness();
    const copied = ref(false);
    let copiedPopupTimeout: ReturnType<typeof setTimeout> | null = null;

    const close = () => {
      emit('input', false);
    };

    const confirm = (which: boolean) => {
      close();
      emit('confirm', which);
    };

    const showCopiedPopup = () => {
      copied.value = true;
      if (copiedPopupTimeout) clearTimeout(copiedPopupTimeout);
      copiedPopupTimeout = setTimeout(() => {
        copied.value = false;
      }, 1400);
    };

    const copyToClipboard = async (value: string): Promise<boolean> => {
      if (!value) return false;

      try {
        if (window.isSecureContext && navigator.clipboard?.writeText) {
          await navigator.clipboard.writeText(value);
          return true;
        }
        return copy(value);
      } catch (error) {
        const copied = copy(value);
        console.error('Clipboard API copy failed, fallback copy was used', error);
        return copied;
      }
    };

    const copyPopupText = async () => {
      const didCopy = await copyToClipboard(props.copyText);
      if (didCopy) showCopiedPopup();
    };

    onBeforeUnmount(() => {
      if (copiedPopupTimeout) clearTimeout(copiedPopupTimeout);
    });

    return {
      confirm,
      close,
      isMobileWidth,
      copied,
      copyPopupText
    };
  }
});
